import { useSelector } from 'react-redux';
import { OrgStatusText } from '../../modules/orgs/interfaces';
import { selectOrgsStatusCount } from '../../modules/orgs/selectors';
import { useTranslation } from 'react-i18next';

export default function OrgStats() {
  const { none, progress, active, inactive } = useSelector(selectOrgsStatusCount);
  const { t } = useTranslation();
  return (
    <section
      aria-label={t('Status for alle dine afdelinger')}
      className="flex flex-wrap items-center gap-x-6 gap-y-2"
    >
      <h2 className="m-0 text-xs font-medium text-muted-foreground">
        {t('Status for alle dine afdelinger')}
      </h2>
      <dl className="m-0 flex flex-wrap gap-x-6 gap-y-2 text-sm">
        {[
          { status: 0, count: none, color: 'bg-slate-400' },
          { status: 1, count: progress, color: 'bg-blue-500' },
          { status: 2, count: active, color: 'bg-emerald-500' },
          { status: 3, count: inactive, color: 'bg-rose-500' },
        ].map(({ status, count, color }) => (
          <div key={status} className="flex items-center gap-2">
            <dt className="flex items-center gap-2 text-muted-foreground">
              <span aria-hidden="true" className={`h-2 w-2 rounded-full ${color}`} />
              {t(OrgStatusText[status as keyof typeof OrgStatusText])}
            </dt>
            <dd className="m-0 font-semibold tabular-nums">{count}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
